var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33366 1.33325C12.2792 1.33325 14.667 3.72107 14.667 6.66659C14.667 9.6121 12.2792 11.9999 9.33366 11.9999C8.10118 11.9999 6.96635 11.5819 6.06323 10.8798L2.47173 14.4713C2.21138 14.7317 1.78927 14.7317 1.52892 14.4713C1.26857 14.211 1.26857 13.7889 1.52892 13.5285L5.12042 9.93702C4.41838 9.03389 4.00033 7.89906 4.00033 6.66659C4.00033 3.72107 6.38814 1.33325 9.33366 1.33325ZM13.3337 6.66659C13.3337 4.45745 11.5428 2.66659 9.33366 2.66659C7.12452 2.66659 5.33366 4.45745 5.33366 6.66659C5.33366 8.87572 7.12452 10.6666 9.33366 10.6666C11.5428 10.6666 13.3337 8.87572 13.3337 6.66659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.07e6b8f8570b689e2a03113ec6207409.svg";
export { ForwardRef as ReactComponent };